export const ColumnHeader = ({ className, children, style }) => (
  <th className={`text-left font-medium text-gray-600 capitalize tracking-wider ${className}`} style={style}>
    {children}
  </th>
);

export const ColumnCell = ({ className, children }) => <td className={`font-medium ${className}`}>{children}</td>;
